import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_MIN_WIDTH } from '~shared/lib/responsive';

import { DesktopMenu } from './desktop-menu';
import { MobileMenu } from './mobile-menu';
import { MenuProps } from './types';

export const ResponsiveMenu = ({ trigger, items }: MenuProps) => {
  const isLargeScreen = useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.sm });

  return isLargeScreen ? (
    <DesktopMenu trigger={trigger} items={items} />
  ) : (
    <MobileMenu trigger={trigger} items={items} />
  );
};
